export function useHttpClient() {
    const { $httpClient } = useNuxtApp()
 
    return $httpClient;
 }
 